import { getConstant } from '../utils';

export const getNutrition = getConstant('GET_NUTRITION');
export const getNutritions = getConstant('GET_NUTRITIONS');
export const clearNutrition = getConstant('CLEAR_NUTRITION');
export const updateNutrition = getConstant('UPDATE_NUTRITION');
export const addNutrition = getConstant('ADD_NUTRITION');
